import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { useDirectContactCsHotlinePushFullStoryTracking } from '../../hooks/useDirectContactCsHotlinePushFullStoryTracking'
import { useDirectContactFormTelephoneTranslations } from '../../hooks/useDirectContactFormTelephoneTranslations'
import { DirectContactTelephoneAvailableBox } from '../DirectContactTelephoneAvailableBox'

export const DirectContactTelephoneDialogAvailable: FC = () => {
  const intl = useIntl()
  const { tenant } = useGlobalConfigContext()

  const { getFooterDisclaimerText } = useDirectContactFormTelephoneTranslations(
    false,
    tenant,
  )

  useDirectContactCsHotlinePushFullStoryTracking()

  const phoneNumber = intl.formatMessage({
    id: 'contact.directContact.customerSupport.phoneNumber',
  })

  return (
    <div className="flex flex-col gap-4">
      <p className="text-m">
        <FormattedMessage id="contact.directContactSection.customerSupportDialog.description" />
      </p>
      <DirectContactTelephoneAvailableBox />
      <Button<'a'>
        className="w-full"
        href={`tel:${phoneNumber}`}
        size="large"
        slots={{ root: 'a' }}
        variant="filled"
      >
        {phoneNumber}
      </Button>
      <p>{getFooterDisclaimerText()}</p>
    </div>
  )
}
